/**
 * Compute Pressure API Detector
 */

export interface ComputePressureResult {
  supported: boolean;
}

export async function detectComputePressure(): Promise<ComputePressureResult> {
  try {
    const PressureObserver = (window as Window & { PressureObserver?: unknown }).PressureObserver;
    return {
      supported: !!PressureObserver,
    };
  } catch (error) {
    return {
      supported: false,
    };
  }
}
